import { Flex, Text } from "@mantine/core"
import { ActivityHeaderCell } from "./activity-header-cell"
import { match } from "ts-pattern"
import { MatrixOrientation } from "../matrix-css-grid"
import {
  ActivityOrPeriodColumn,
  FormulaDto,
} from "../../../../../../@client/Theasoft_ApiServer_Orchestra"
import dayjs from "dayjs"
import { DayBorderCell } from "./day-border-cell"
import css from "./cells.module.css"
import { SuspenseWithFallback } from "../../../../../../-components/suspense"

// the x dimension (in normal) mode are activities/periods (before noon, after noon/evening)
// and these are grouped by day
export type DataXGroup = {
  day: dayjs.Dayjs
  span: number
}
// x dimension are formulas (first column) or activities/periods

export type DataX_Sum = {
  width: number
  type: "formula"
  data: FormulaDto
  group: null
  isFirst: boolean
}

export type DataX_Activity = {
  width: number
  type: "activity"
  data: ActivityOrPeriodColumn
  group: DataXGroup
  isFirst: boolean
}

export type DataX_DayChange = {
  width: number
  type: "day_change"
  isFirst: boolean
  group: DataXGroup
}

export type ActivityOrDayChangeOrFormula =
  | DataX_Sum
  | DataX_Activity
  | DataX_DayChange

export function ActivityOrPeriodHeaderCell({
  x,
  orientation,
  departmentId,
}: {
  x: ActivityOrDayChangeOrFormula
  orientation: MatrixOrientation
  departmentId: number
}) {
  return (
    <div
      className={css["activity-or-period-header-cell"]}
      style={{
        left: orientation == "transpose" ? 28 : undefined,
        top: orientation == "normal" ? 28 : undefined,
        borderBottom: orientation == "transpose" ? "none" : undefined,
        borderRight: orientation == "normal" ? "none" : undefined,
      }}
    >
      {match(x)
        .with({ type: "activity" }, (x) =>
          x.data.activityDto ? (
            <SuspenseWithFallback loadingProps={{ type: "dots" }}>
              <ActivityHeaderCell
                activity={x.data.activityDto}
                departmentId={departmentId}
              />
            </SuspenseWithFallback>
          ) : (
            <Text size={"xs"} mih={24}>
              {x.data.caption}
            </Text>
          )
        )
        .with({ type: "day_change" }, () => <DayBorderCell />)
        .with({ type: "formula" }, (x) => (
          <Flex
            align="center"
            direction={orientation === "normal" ? "column" : "row"}
            h={"100%"}
            style={{
              overflow: "hidden",
              paddingLeft: orientation === "transpose" ? 4 : undefined,
              paddingTop: orientation === "normal" ? 4 : undefined,
            }}
          >
            <Text
              fw={700}
              c="dimmed"
              size={"xs"}
              style={
                orientation === "normal"
                  ? {
                      writingMode: "vertical-lr",
                      transform: "rotate(-180deg)",
                    }
                  : undefined
              }
            >
              {x.data.name}
            </Text>
          </Flex>
        ))
        .exhaustive()}
    </div>
  )
}
